<template>
    <div class="header">
        <img src="@/assets/images/logo.svg" alt="logo" class="logo" />
    </div>
</template>

<script>
export default {
  name: 'premiumHeader',
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
    .header {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        padding-left: 235px;
        background-color: #ffffff;
        .logo {
            width: 197px;
            height: 36px;
        }
    }

    @media screen and (max-width: 750px) {
        .header {
            width: 100%;
            height: 50px;
            padding-left: 20px;
            .logo {
                width: 140px;
                height: 26px;
            }
        }
    }
</style>